import { Button, Link, Modal, Text } from '@stitch-fix/mode-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import reactStringReplace from 'react-string-replace';
import './ErrorAlert.module.scss';

/**
 * This replaces text containing "contact us" with a link to our support page.
 *
 * @param {*} text
 * @returns the input text with "contact us" replaced with a clickable link to support.
 */
const textWithLinks = text => {
  const reg = /(contact us)/i;

  return reactStringReplace(text, reg, (match, i) => (
    <Link
      key={i}
      size="tertiary"
      href="https://support.stitchfix.com/hc/en-us/requests/new"
      underline="initial"
    >
      {match}
    </Link>
  ));
};

/**
 * A fairly basic modal for general error displays. Takes a heading and text.
 *
 * @param {*} props.heading The heading for the alert
 * @param {*} props.text The text for the alert. Note that instances of "contact us" will be replaced with a link to our support page.
 */
const ErrorAlert = ({ heading, text }) => {
  const [hidden, setHidden] = useState(false);

  return (
    <Modal
      isOpen={!hidden}
      variant="inset-small"
      onClose={() => setHidden(true)}
    >
      {/* HACK: preserving legacy centered-ness of this component */}
      <Text align="center" setting="title-small" mx={1}>
        {heading}
      </Text>

      <Text
        align="center"
        color="gray-16"
        setting="body-medium"
        mx={0.25}
        my={1.25}
      >
        {textWithLinks(text)}
      </Text>

      {/* HACK: preserving legacy centered-ness of this component */}
      <div styleName="btn-container">
        <Button
          width={{ sm: 'fill', md: 'fixed' }}
          onClick={() => setHidden(true)}
        >
          Got it
        </Button>
      </div>
    </Modal>
  );
};

ErrorAlert.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ErrorAlert;
